import { useTranslation } from 'react-i18next'

import Button from '../../Button'
import PageEmptyState from '../PageEmptyState'
import { getEmptyStateActions } from '../PageEmptyState.utils'

import {
  PAGE_EMPTY_STATE_LOAD_ERROR_RETRY_ACTION_NAME,
  QA_NAME_PAGE_EMPTY_STATE_LOAD_ERROR_RETRY,
} from './PageEmptyStateLoadError.constants'

import RefreshIcon from '../../../icons/refresh.svg'

function PageEmptyStateLoadError({ EntityIcon, onClickRetry }) {
  const { t } = useTranslation()

  return (
    <PageEmptyState
      EntityIcon={EntityIcon}
      actions={getEmptyStateActions({
        Component: Button.Flat,
        Icon: RefreshIcon,
        actionName: PAGE_EMPTY_STATE_LOAD_ERROR_RETRY_ACTION_NAME,
        qaName: QA_NAME_PAGE_EMPTY_STATE_LOAD_ERROR_RETRY,
        shouldShowActions: true,
        text: t('Common.TryAgainBtnKey'),
        onClick: onClickRetry,
      })}
      text={t('Error.CommonApiRequestFailKey')}
    />
  )
}

export default PageEmptyStateLoadError
